import { render, staticRenderFns } from "./FileViewerHTML.vue?vue&type=template&id=d5ae13f2&scoped=true&"
import script from "./FileViewerHTML.vue?vue&type=script&lang=ts&"
export * from "./FileViewerHTML.vue?vue&type=script&lang=ts&"
import style0 from "./FileViewerHTML.vue?vue&type=style&index=0&id=d5ae13f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ae13f2",
  null
  
)

export default component.exports